import { useState } from "react";

import { makePostApiCall } from "../../../shared/makeApiCall";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";
import subDays from "date-fns/subDays";
import { SnackbarData, SnackbarType } from "../../../components/Snackbar";
import { generateUniqueNumber } from "../../../shared/utility";

export function AllReceivingInvoicesViewModel(logout, addSnackbar) {
  const defaultFilters = {
    startDate: subDays(new Date(), 7),
    endDate: new Date(),
  };
  const [filters, setFilters] = useState(defaultFilters);
  const [showDates, setShowDates] = useState(false);

  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [receivingInvoices, setReceivingInvoices] = useState({
    data: [],
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });

  const getReceivingInvoices = async function (search, page) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
      filters: filters,
    };
    let callResult = await makePostApiCall(`receivingInvoices`, payload);
    setLoading(false);
    if (callResult.success) {
      setReceivingInvoices(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const deleteReceivingInvoice = async function (invoiceId, index) {
    let callResult = await makePostApiCall(
      `deleteReceivingInvoice/${invoiceId}`,
      {},
    );
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
      getReceivingInvoices(null, 0);

      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success,
        ),
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteReceivingInvoice = function (invoice, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteReceivingInvoice(invoice.id, index)}
          message={`Are you sure you want to delete invoice ${invoice.invoice_number} from ${invoice.supplier_name}?`}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  return {
    askDeleteReceivingInvoice,
    emptyModal,
    getReceivingInvoices,
    loading,
    receivingInvoices,
    setSlideOver,
    slideOver,
    setEmptyModelOpen,
    setFilters,
    showDates,
    setShowDates,
    filters,
  };
}
